import React from 'react'
import EmptyLoader from '../shared/components/EmptyLoader/EmptyLoader'
//TODO: replace with loader when it's ready
const ScreenLoading = () => <EmptyLoader />

export default ScreenLoading
